import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { GlobalVariable} from '../global';

@Injectable()
export class OrganisationData {
  private apiUrl = GlobalVariable.BASE_API_URL; //get api url
  constructor(
    public events: Events,
    public storage: Storage,
    public http: HttpClient
  ) {}

  getOrganisation(){
      return this.http.get(this.apiUrl + 'organisation')
  }
}



// WEBPACK FOOTER //
// ./src/providers/organisation-data.ts